/* eslint-disable
    func-names,
    guard-for-in,
    no-restricted-syntax,
    no-shadow,
    no-underscore-dangle,
    no-unused-vars,
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const factory = function (ViewModel, $sce, CurrencyCollection, Relation, _) {
  let DocumentVM;
  const isNum = num => /^\d+$/.test(num);

  return (DocumentVM = (function () {
    DocumentVM = class DocumentVM extends ViewModel {
      static initClass() {
        this.prototype.documentId = null;
        this.prototype.$idName = 'id';

        this.prototype.$document = Relation('Document', 'documentId');
        this.prototype.$client = Relation('Client', 'clientId');
        this.prototype.$file = Relation('File', 'fileId');
      }

      $init(data) {
        if (isNum(this.$storeId())) {
          this.documentId = this.$storeId();
        }

        this.$listen(this.$document());

        this.$set(this.$document().$data());
        this.$set(data);

        return this.$bindAttr(
          'exchangeRate',
          function () {
            return this.currencyId;
          },
          function () {
            return this.$exchangeRate();
          },
        );
      }

      hasForeignCurrency() {
        return String(this.currencyId) !== this.$client().currencyId;
      }

      $currencyCode() {
        const currencies = new CurrencyCollection();
        const currentCurrency = currencies.$findById(this.currencyId);
        return currentCurrency.code;
      }

      $exchangeRate() {
        const rateModel = __guardMethod__(
          __guardMethod__(
            typeof this.$client === 'function' ? this.$client() : undefined,
            'exchangeRates',
            o1 => o1.exchangeRates(),
          ),
          '$findById',
          o => o.$findById(String(this.currencyId)),
        );
        return rateModel != null ? rateModel.rate : undefined;
      }

      $listenTransformFn(newData) {
        const transformedData = {};

        for (const key in newData) {
          const val = newData[key];
          transformedData[key] = isNum(val) ? Number(val) : val;
        }

        return transformedData;
      }

      $getPdfPath() {
        if (this.fileId != null) {
          return $sce.trustAsResourceUrl(
            this.$apiService.href(`/file.json/${this.fileId}/download`),
          );
        }
        return null;
      }
    };
    DocumentVM.initClass();
    return DocumentVM;
  })());
};

const moduleDeps = [
  require('data/util').name,
  require('data/collection/transaction').name,
  require('data/collection/currency').name,
];

module.exports = angular
  .module('bench.data.viewmodel.document', moduleDeps)
  .factory('DocumentVM', factory);

function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  }
  return undefined;
}
